var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailReadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.55.945c.8-.487 1.8-.487 2.6 0l5.81 3.551a2.488 2.488 0 0 1 1.19 2.124v8.2c0 1.375-1.11 2.49-2.49 2.49H3.04a2.493 2.493 0 0 1-2.49-2.49v-8.2c0-.867.45-1.672 1.19-2.124L7.55.945Zm1.73 1.417a.817.817 0 0 0-.86 0L3.05 5.644 8.32 9.99c.31.252.75.252 1.06 0l5.28-4.346-5.38-3.282Zm6.21 4.744-3.13 2.579 3.13 3.131v-5.71Zm-4.42 3.639-.64.526a2.48 2.48 0 0 1-3.16 0l-.64-.526-4.37 4.366c.12.315.42.539.78.539h11.62c.36 0 .66-.224.78-.539l-4.37-4.366Zm-5.73-1.06L2.21 7.106v5.71l3.13-3.131Z",
  fill: "currentColor"
})));
export { SvgEmailReadIcon as ReactComponent };
export default __webpack_public_path__ + "images/email-read-icon.svg";